const SalePortal = () => import("./sale-portal.vue");
const OnHold = () => import("./onhold.vue");
const ImportSales = () => import("./sales-import.vue");
const UploadedInvoices = () => import("./uploaded-invoices.vue");
const DailySales = () => import("./_pages/daily-sales.vue");
const SoldProducts = () => import("./_pages/sold-products.vue");
const DiscountedSales = () => import("./_pages/discounted-sales.vue");
const SalesVsSock = () => import("./_pages/sales-vs-stock.vue");
const OwnerZReport = () => import("./_pages/owner-z-report.vue");
const Payments = () => import("./_pages/payments.vue");
const Expenses = () => import("./_pages/expenses.vue");
const Purchases = () => import("./_pages/purchases.vue");
const AccountsStatement = () => import("./_pages/statement.vue");
const StockTransfer = () => import("./_pages/stock-transfer.vue");
const SaleDetails = () => import("./_pages/view.vue");
const SalePreview = () => import("./_pages/sale-preview.vue");
const ReturnDetails = () => import("./_pages/return-details.vue");
const ProfitReport = () => import("./_pages/profit-report.vue");
const CloseAccounts = () => import("./_pages/close-accounts.vue");
const ZReport = () => import("./_pages/z-report.vue");
const StartingFloatIndex = () => import("./starting-float/index.vue");
const StartingFloatNew = () => import("./starting-float/_pages/create.vue");
const StartingFloatView = () => import("./starting-float/_pages/view.vue");
const ImportBuyingPrices = () => import("./_pages/import-buying-prices.vue");

export default [
  {
    path: "/import-buying-prices",
    component: ImportBuyingPrices,
  },
  {
    path: "/starting-float",
    component: StartingFloatIndex,
  },
  {
    path: "/new-starting-float",
    component: StartingFloatNew,
  },
  {
    path: "/starting-float/:id",
    component: StartingFloatView,
  },
  {
    path: "/close/accounts",
    component: CloseAccounts,
  },
  {
    path: "/z-report",
    component: ZReport,
  },
  {
    path: "/owner-z-report",
    component: OwnerZReport,
  },
  {
    path: "/discounted-sales",
    component: DiscountedSales,
  },
  {
    path: "/sales-vs-stock",
    component: SalesVsSock,
  },
  {
    path: "/pos",
    component: SalePortal,
  },
  {
    path: "/on-hold",
    component: OnHold,
  },
  {
    path: "/import-sales",
    component: ImportSales,
  },
  {
    path: "/uploaded-invoices/:id",
    component: UploadedInvoices,
  },
  {
    path: "/pos/daily/sales",
    component: DailySales,
  },
  {
    path: "/pos/sold/products",
    component: SoldProducts,
  },
  {
    path: "/pos/payments",
    component: Payments,
  },
  {
    path: "/pos/profit/report",
    component: ProfitReport,
  },
  {
    path: "/pos/expenses",
    component: Expenses,
  },
  {
    path: "/pos/purchases",
    component: Purchases,
  },
  {
    path: "/pos/stock/transfer",
    component: StockTransfer,
  },
  {
    path: "pos/sale-details/:id",
    component: SaleDetails,
  },
  {
    path: "sale-preview/:id",
    component: SalePreview,
  },
  {
    path: "daily/return/:id",
    component: ReturnDetails,
  },
  {
    path: "accounts/statement",
    component: AccountsStatement,
  },
];
